/* Cymballand – Größenwahl auf Produktkarten (snippets/product-card-sizes.liquid) */
(function () {
  if (window.clVs) return;
  window.clVs = true;
  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('.cl-vs-chip') : null;
    if (!chip || chip.disabled) return;
    e.preventDefault();
    var card = chip.closest('product-card');
    if (!card) return;
    var t = card.querySelector('template.cl-vs-t[data-vid="' + chip.dataset.vid + '"]');
    if (!t) return;
    var c = t.content;
    var price = card.querySelector('.cl-vs-price');
    var np = c.querySelector('[data-p]');
    if (price && np) price.innerHTML = np.innerHTML;
    var ob = card.querySelector('.product-card--badges');
    var nb = c.querySelector('[data-b] .product-card--badges');
    if (ob && nb) ob.replaceWith(nb.cloneNode(true));
    var url = t.dataset.url, title = t.dataset.title;
    card.querySelectorAll('a.product-card-image-link, a.product-card-title, a.product-card--view-details, a.cl-vs-link').forEach(function (a) {
      a.setAttribute('href', url);
      if (a.hasAttribute('title')) a.setAttribute('title', title);
    });
    var tl = card.querySelector('.product-card-title');
    if (tl) tl.textContent = title;
    var btn = card.querySelector('.product-card--add-to-cart-button-simple');
    var link = card.querySelector('.cl-vs-link');
    if (t.dataset.mode === 'add') {
      if (btn) { btn.dataset.productId = chip.dataset.vid; btn.hidden = false; }
      if (link) link.hidden = true;
    } else {
      if (link) {
        var s = link.querySelector('.product-card--add-to-cart-text');
        if (s) s.textContent = t.dataset.btn;
        link.hidden = false;
      }
      if (btn) btn.hidden = true;
    }
    card.querySelectorAll('.cl-vs-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', b === chip ? 'true' : 'false');
    });
  });
})();

/* Cymballand – Cymballand-Virtual-Popup auf Produktkarten (Button .cl-vp-btn in snippets/product-card.liquid)
   URL-Logik = Produktseite (templates/product.json → Custom-Liquid "Cymballand Virtual", buildUrl).
   NO = Größen, die es in Cymballand Virtual NICHT gibt (geprüft 17.10.2026) → dort wird der Button ausgeblendet.
   Neue Größe ohne Virtual-Eintrag? Hier ergänzen: 'serie|typ größe' (so wie in der Virtual-URL). */
(function () {
  if (window.clVp) return;
  window.clVp = true;
  var BASE = 'https://www.cymballandvirtual.de/';
  var NO = ['classic|crash 15', 'classic|hi-hat 12', 'classic|splash dark 9', 'ephesus|crash 19', 'jazz|crash 18',
    'kurak|china thin 17', 'rock beat|crash thin 16', 'studio|crash 14', 'studio|splash 10', 'studio|splash 12', 'travel|crash 18'];
  function params(series, type, variantTitle) {
    variantTitle = String(variantTitle || '');
    var size = variantTitle.replace(/[^0-9]/g, '');
    var map = { 'hihat': 'hi-hat', 'fx-hi-hat': 'fx hi-hat', 'snake-hi-hat': 'snake hi-hat', 'hi-hat-light': 'hi-hat light',
      'j.b.-hi-hat': 'j.b. hi-hat', 'hi-hat-jazz': 'hi-hat jazz', 'lale-hi-hat': 'lale hi-hat', 'hi-hat-holey': 'hi-hat holey' };
    var cymballType = map[type] || type.replace(/-/g, ' ');
    if (series === 'classic' && type === 'ride' && size === '24') cymballType = 'xl ride';
    if (series === 'stack') {
      var n = variantTitle.indexOf('18') > -1 ? '1' : variantTitle.indexOf('16') > -1 ? '2' : '3';
      return { series: 'stack', cymball: 'Stack ' + n };
    }
    return { series: series, cymball: cymballType + ' ' + size };
  }
  function current(btn) {
    var card = btn.closest('product-card');
    var chip = card ? card.querySelector('.cl-vs-chip[aria-pressed="true"]') : null;
    return params(btn.dataset.series, btn.dataset.type, chip ? chip.textContent.trim() : btn.dataset.size);
  }
  function sync(btn) {
    var p = current(btn);
    btn.hidden = NO.indexOf((p.series + '|' + p.cymball).toLowerCase()) > -1;
  }
  function syncAll() { document.querySelectorAll('.cl-vp-btn').forEach(sync); }
  var HINT = {
    de: 'Klick oder tipp aufs Becken und hör rein',
    en: 'Click or tap the cymbal to hear it',
    fr: 'Cliquez ou touchez la cymbale pour l’écouter',
    es: 'Haz clic o toca el plato para escucharlo',
    it: 'Clicca o tocca il piatto per ascoltarlo',
    pt: 'Clique ou toque no prato para o ouvir',
    nl: 'Klik of tik op het bekken om het te horen',
    pl: 'Kliknij lub dotknij talerza, aby go usłyszeć',
    el: 'Πατήστε στο πιατίνι για να το ακούσετε',
    hu: 'Kattints vagy koppints a cintányérra, és hallgasd meg',
    no: 'Klikk eller trykk på bekkenet for å høre det',
    nb: 'Klikk eller trykk på bekkenet for å høre det',
    ja: 'シンバルをクリック／タップして試聴'
  };
  function hintText() {
    var l = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    return HINT[l] || HINT.en;
  }
  var ov, box, frame;
  function layout() {
    if (!ov || !ov.classList.contains('is-open')) return;
    var vw = window.innerWidth, vh = window.innerHeight, s, w, h;
    if (vw < 768) {
      /* Telefon: quadratischer Ausschnitt wie auf der Produktseite (mobil) */
      w = Math.min(vw - 32, vh - 120, 500); h = w; s = w / 765;
      frame.style.transform = 'scale(' + s + ') translate(-310px,-7px)';
    } else {
      /* Desktop: ganzer Player wie im Vollbild-Popup der Produktseite */
      w = Math.min(vw * 0.9, 1050, (vh * 0.9) * 1400 / 800); s = w / 1400; h = Math.round(800 * s);
      frame.style.transform = 'scale(' + s + ')';
    }
    box.style.width = Math.round(w) + 'px';
    box.style.height = Math.round(h) + 'px';
  }
  function close() {
    if (!ov) return;
    ov.classList.remove('is-open');
    frame.src = 'about:blank';
    document.documentElement.style.overflow = '';
  }
  function open(url) {
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'cl-vp-ov';
      ov.setAttribute('role', 'dialog');
      ov.setAttribute('aria-modal', 'true');
      ov.innerHTML = '<div class="cl-vp-wrap"><p class="cl-vp-hint"><span class="cl-vp-stick" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24"><path d="M2.4 20.4 3.6 21.6 18.2 7.6 16.4 5.8Z" fill="#fff"/><ellipse cx="18.6" cy="5.4" rx="2.7" ry="1.9" transform="rotate(-45 18.6 5.4)" fill="#fff"/></svg></span>' + hintText() + '</p><div class="cl-vp-box"><iframe class="cl-vp-frame" scrolling="no" title="Cymballand Virtual"></iframe><button type="button" class="cl-vp-x" aria-label="Close">✕</button></div></div>';
      document.body.appendChild(ov);
      /* Hinweis ausblenden, sobald jemand ins Becken klickt (Fokus wandert ins iframe) */
      window.addEventListener('blur', function () {
        if (ov.classList.contains('is-open') && document.activeElement === frame) ov.classList.add('is-played');
      });
      box = ov.querySelector('.cl-vp-box');
      frame = ov.querySelector('.cl-vp-frame');
      /* nach dem Laden neu zeichnen lassen (sonst bleibt das iframe in manchen Browsern schwarz) */
      frame.addEventListener('load', function () {
        frame.style.transform = 'none';
        requestAnimationFrame(layout);
      });
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('.cl-vp-x')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      window.addEventListener('resize', layout);
    }
    frame.src = url;
    ov.classList.remove('is-played');
    ov.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    layout();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.cl-vp-btn') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var p = current(btn);
      open(BASE + '?series=' + p.series + '&cymball=' + encodeURIComponent(p.cymball));
    }
  }, true);
  /* Größenwechsel (Chip) läuft im Bubble-Handler oben → nach dem Klick neu prüfen */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('.cl-vs-chip') : null;
    var card = chip ? chip.closest('product-card') : null;
    var b = card ? card.querySelector('.cl-vp-btn') : null;
    if (b) sync(b);
  });
  syncAll();
  document.addEventListener('DOMContentLoaded', syncAll);
  /* Nachgeladene Karten (Filter, Empfehlungen, Suche) */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; syncAll(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
